import { HubConnectionState } from '@microsoft/signalr';
import { create } from 'zustand';

export default create((set) => ({
    status: 'disconnected',
    connectionId: null,
    authenticated: false,
    lastConnect: null,
    lastDisconnect: null,

    setStatus: (status) => {
        set(() => ({ status }));
        switch (status) {
            case HubConnectionState.Connected:
                set(() => ({ lastConnect: new Date().getTime() }));
                break;

            case HubConnectionState.Disconnected:
                set(() => ({ lastDisconnect: new Date().getTime() }));
                break;

            default:
                return;
        }
    },
    setConnectionId: (connectionId) => {
        set(() => ({ connectionId }));
    },
    setAuthenticated: (authStatus) =>
        set(() => ({ authenticated: authStatus })),
}));
